import { client } from ".";

export const getGeneratedAgoraToken = async (channelName, uid, { userId, userType = "astrologer" } = {}) => {
  // userId+userType added for server-side membership check on
  // /api/consultation/call/token. Server currently warns-and-allows
  // missing context; this will flip to required once all clients ship.
  const {
    data: { token },
  } = await client.get(`/api/consultation/call/token`, {
    params: { channelName, uid, userId, userType },
  });

  return token;
};

export const postFcmToken = async (userId, token, userType = "astrologer") => {
  const { status } = await client.post(`/api/notifications/token`, {
    userId,
    userType,
    token,
  });

  return { status };
};

export const validateMeetingToken = async (
  token,
  userId,
  userType = "astrologer"
) => {
  try {
    const {
      data: { data },
    } = await client.post(`/api/meeting/validate-token`, {
      token,
      userId,
      userType,
    });

    return data;
  } catch (err) {
    throw new Error(`Unable to Validate Meeting Token: ${err}`);
  }
};

export const getNewAgoraChatToken = async (userId) => {
  const {
    data: { token, uuid },
  } = await client.get(`/api/consultation/chat/token`, {
    params: { userId, userType: "astrologer" },
  });

  return { token, uuid };
};

export const getAgoraChatRenewalToken = async (uuid) => {
  const {
    data: { token },
  } = await client.get(`/api/consultation/chat/renewal`, {
    params: { uuid },
  });

  return { token };
};
